import React,{Component} from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Alert,
  Row,
  Col
} from 'reactstrap';

class NotificationTray extends Component {
  componentDidUpdate(nextProps,nextState){
    //HIDE NOTIFICATION IF
  }

  getColorForNotificationKind(kind){
    if(kind === 'error') return 'danger';
    if(kind === 'success') return 'success';
    if(kind === 'info') return 'info';
    return 'success';
  }

  render(){
    const notificationAtTopOfStack = this.props.notifications[0];

    if(!notificationAtTopOfStack){
      return null;
    } else {
      const { message, kind, id } = notificationAtTopOfStack;

      return (
        <Container
          className='no-print'
          style={{
            position:'absolute',
            left:0,
            top:70,
            right:0,
            zIndex:10,
            pointerEvents:'none'
          }}
        >
          <Row>
            <Col 
              xs={{size:8,offset:2}}
              style={{pointerEvents:'auto'}}
            >
              <Alert
                isOpen
                color={this.getColorForNotificationKind(kind)}
                toggle={() => this.props.onDismiss(id)}
              >
                <span
                  dangerouslySetInnerHTML={{__html:message}}
                />
              </Alert>
            </Col>
          </Row>
        </Container>
      )
    }
  }
}


NotificationTray.propTypes = {
  notifications:PropTypes.arrayOf(PropTypes.shape({
    message:PropTypes.string,
    kind:PropTypes.oneOf(['error','success','info']),
    id:PropTypes.string
  })),
  onDismiss:PropTypes.func
};

NotificationTray.defaultProps = {
  notifications:[]
}

export default NotificationTray;



// WEBPACK FOOTER //
// ./src/shared/components/NotificationTray/index.js